import classNames from "classnames";
import { CSSProperties } from "react";
import * as React from "react";
import { FunctionComponent } from "react";
import * as styles from "./SpriteAvatar.less";

type SpriteSizes = 24 | 32 | 40 | 48 | 100;
export enum AvatarSizes {
    Small = 24,
    Medium = 32,
    Large = 40,
    ExtraLarge = 48,
    Huge = 100,
}

interface SpriteAvatarProps {
    size: SpriteSizes;
    userId?: number;
    unnamedResourceId?: number;
    teamId?: number;
    name?: string;
    round?: boolean;
    disabled?: boolean;
    className?: string;
}

export const SpriteAvatar: FunctionComponent<SpriteAvatarProps> = ({
    size,
    userId,
    name,
    unnamedResourceId,
    teamId,
    round = true,
    disabled = false,
    className,
}) => {
    const style = React.useMemo(
        () =>
            ({
                flexShrink: 0,
                borderRadius: round ? "50%" : 0,
                borderBottom: round && "1px solid transparent",
                boxSizing: round && "border-box",
                filter: disabled ? "grayscale(1)" : undefined,
            } as CSSProperties),
        [round, disabled]
    );

    let avatarClassName =
        (!!userId && `avatar_${size}_${userId}`) ||
        (!!unnamedResourceId && styles.unnamed_resource) ||
        (!!teamId && styles.team) ||
        `avatar_${size}_0`;

    return (
        <div
            role="img"
            className={classNames(`user-avatar avatar_${size}`, avatarClassName, className)}
            style={style}
            aria-label={name}
        />
    );
};
